import * as React from 'react';
import System from "src/helper/system";

const ThankYouPopup = (props) => {
    const { SetStatus, data } = props;
    const getTitleText = () => {
        if (data.isQuote) {
            return 'Confirmation';
        }
        if (data.isOrderHistory) {
            return ' Thanks for your request';
        }
        if (data?.isRegister) {
            return 'Thank You';
        }
        if (data?.isPDPShare) {
            return 'Message Sent';
        }
        if (data?.isAccountInActive) {
            return 
        }
        return 'Feedback Received';
    }
    const getBodyText = () => {
        if (data.isPDP) {
            return 'Many thanks for your feedback, our experts will look into this.'
        }
        if (data.isPDPShare) {
            return 'Your Email has been sent.'
        }
        if (data.isQuote) {
            return 'Your message has been sent successfully.'
        }
        if (data.isOrderHistory) {
            return 'We will send your order history details to your email.'
        }
        if (data.isAccountInActive) {
            return (
                <p>
                    You are unable to place an order at this time as your account is currently inactive. Please contact <a href="mailto:CMD@Avnet.com" className='text-blue2'>CMD@Avnet.com</a> for more information
                </p>
            )
        }
        if (data?.isRegister) {
            return (
                <p>
                    You will receive an email with the temporary password. If you don't receive this email contact: Avnet Americas Online Support Team Phone: 1-800-408-8353 or <a href="mailto:onlinesupportUS@avnet.com" className='text-decoration-underline'>onlinesupportUS@avnet.com</a>
                </p>
            )
        }
        return 'Your email has been sent.'
    }

    const getFooterButtonText = () => {
        if (data?.isOrderHistory || data?.isPDPShare) {
            return 'Close'
        }
        if (data?.isRegister) {
            return 'CONTINUE';
        }
        if (data?.isAccountInActive) {
            return 'CLOSE'
        }
        return 'Ok';
    }
    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    {!data?.isRegister && (

                        <button type="button" className="close" data-dismiss="modal"
                            onClick={() => {
                                SetStatus(false)
                            }}>×
                        </button>
                    )}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading">
                            {data?.isRegister ?
                                <span className='text-darkgreen'>{getTitleText()} </span>
                                : getTitleText()}
                        </h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="text-center mb-3">
                            {getBodyText()}
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-primary minw-auto"
                                onClick={() => {
                                     if (data?.isRegister) {
                                         window.location.href = System.getPreviousPageUrl()
                                     } else {
                                         SetStatus(false)
                                     }
                                }}
                            >
                                {getFooterButtonText()}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ThankYouPopup;